/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'

import { EuiTourStep, EuiButtonEmpty } from '@elastic/eui'

import { FormattedMessage } from '@modules/i18n'

import useBudgetTour from './useBudgetTour'

import type { ReactElement } from 'react'

const BudgetTourSecondStep: React.FunctionComponent<{ children: ReactElement }> = ({
  children,
}) => {
  const { showTour, closeTour, totalSteps } = useBudgetTour()

  return (
    <EuiTourStep
      content={
        <FormattedMessage
          id='budget-tour.second-step.content'
          defaultMessage='Create an organization-wide budget. We will email you if your usage reaches the target amount. This is a soft limit, so your services will continue to run without interruption.'
        />
      }
      maxWidth={350}
      isStepOpen={showTour}
      step={2}
      stepsTotal={totalSteps}
      title={
        <FormattedMessage
          id='budget-tour.second-step.title'
          defaultMessage='Set your first budget'
        />
      }
      subtitle={
        <FormattedMessage
          id='budget-tour.subtitle'
          defaultMessage='NEW - Budgets and notifications'
        />
      }
      onFinish={closeTour}
      footerAction={[
        <EuiButtonEmpty size='s' color='text' onClick={closeTour}>
          <FormattedMessage id='budget-tour.close-tour' defaultMessage='Close tour' />
        </EuiButtonEmpty>,
      ]}
    >
      {children}
    </EuiTourStep>
  )
}

export default BudgetTourSecondStep
